<template>
  <UserSelector v-model="localValue" @user="impersonate"/>
</template>

<script lang="ts">
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import User from "@/entity/User";
import {api} from "@/services/Api";
import {auth} from "@/services/Auth";
import UserSelector from "@/components/UserSelector.vue";

@Component({
  components: {UserSelector}
})
export default class UserImpersonator extends Vue {

  @Prop({default: ''}) value?: string;

  localValue?: string = ''


  @Watch('value')
  computed() {
    this.localValue = this.value
  }

  async impersonate(user: User) {
    const res = await api.get(api.auth, 'auth/manager/impersonate/' + user.id)
    if (res && res.data && res.data.token && res.data.refreshToken) {
      await auth.impersonate(res.data)
      window.location.reload()
    }
  }
}
</script>


<style scoped>

</style>
